import { PATHWAY, GOAL } from "@/data/copy";
import { SectionHeading } from "@/components/common/SectionHeading";
import { accent } from "@/lib/ui";

export const TreatmentPathway = () => (
  <section className="section relative overflow-hidden" aria-labelledby="pathway-heading">
    <div className="container-x">
      <SectionHeading id="pathway-heading" eyebrow="How we work" title="Our Treatment Pathway" intro="A clear, step-by-step approach — from listening to your story to reviewing your progress." />
      <ol className="relative mt-14 grid gap-8 lg:grid-cols-5 lg:gap-6">
        <span className="absolute left-6 top-6 hidden h-1 w-[calc(100%-3rem)] rounded-full bg-gradient-to-r from-brand-sky via-brand-green to-brand-coral opacity-40 lg:block" aria-hidden="true" />
        <span className="absolute bottom-6 left-6 top-6 w-1 -translate-x-1/2 rounded-full bg-gradient-to-b from-brand-sky via-brand-green to-brand-coral opacity-40 lg:hidden" aria-hidden="true" />
        {PATHWAY.map((step, i) => (
          <li key={step.title} className="group relative flex gap-5 lg:flex-col" data-testid={`pathway-step-${i + 1}`}>
            <span className={`relative z-10 flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl font-heading text-lg font-bold shadow-lg ring-8 ring-white transition-transform duration-300 group-hover:-translate-y-1 group-hover:rotate-3 ${accent(i).icon}`}>
              {i + 1}
            </span>
            <div>
              <h3 className="text-lg font-bold text-brand-ink">{step.title}</h3>
              <p className="mt-2 text-base leading-relaxed text-slate-600">{step.text}</p>
            </div>
          </li>
        ))}
      </ol>
      <div className="relative mt-14 overflow-hidden rounded-[2rem] bg-brand-navy px-6 py-8 sm:px-10 sm:py-10" data-testid="pathway-goal">
        <span className="blob -right-10 -top-16 h-56 w-56 bg-brand-sky/40" aria-hidden="true" />
        <span className="blob -bottom-20 left-1/3 h-48 w-48 bg-brand-lime/30" aria-hidden="true" />
        <p className="relative text-xs font-semibold uppercase tracking-[0.2em] text-[#9FD27A]">Our goal</p>
        <p className="relative mt-3 font-heading text-2xl font-bold text-white sm:text-3xl">
          {GOAL.map((g, i) => <span key={g} className={i % 2 ? "text-[#9FD27A]" : ""}>{g} </span>)}
        </p>
      </div>
    </div>
  </section>
);
